import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Toaster } from "sonner";
import { SITE_WRAP, SiteFooter, SiteHeader } from "../site/layout";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => (
    <>
      <Outlet />
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid rgba(11,11,11,0.08)",
            color: "#0b0b0b",
            borderRadius: 14,
            fontFamily: "var(--vx-font)",
          },
        }}
      />
    </>
  ),
  notFoundComponent: NotFound,
});

function NotFound() {
  return (
    <div className="vx flex min-h-dvh flex-col overflow-x-clip">
      <SiteHeader />
      <main className="flex-1">
        <section aria-labelledby="nf-h" className={`${SITE_WRAP} pt-[150px] pb-24 md:pt-[200px] md:pb-32`}>
          <p className="ds-kicker">Error 404</p>
          <h1 id="nf-h" className="ds-display mt-6 max-w-[900px] text-[clamp(48px,7vw,104px)]">
            This vault door doesn't <span className="ds-it">exist.</span>
          </h1>
          <p className="mt-6 max-w-[520px] text-[18px] leading-[1.55] text-(--vx-ink-2)">
            The page moved or never existed. Your vaults are safe: they live on-chain, not on this page.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link to="/" className="ds-btn ds-btn-primary">
              <ArrowLeft size={18} strokeWidth={2} aria-hidden="true" /> Back home
            </Link>
            <Link to="/app" className="ds-btn ds-btn-line">
              Open the app
            </Link>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
